import { computed, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

// True when the operator is viewing extraction data. Extraction routes own
// their workspace chrome and use a full-bleed layout.
export function useIsExtractionView(): ComputedRef<boolean> {
  const route = useRoute()
  return computed(() => route.meta?.isExtractionView === true)
}
